import { useEffect, useState } from "react";
import { AUTH_CHANGE_EVENT, readAuthSession } from "@/lib/authToken";

// Re-reads fsrs_token when login, signup, or sign-out writes it, including
// a same-tab storeAuthToken call that does not navigate.
export function useAuthSession() {
    const [session, setSession] = useState(() => readAuthSession());

    useEffect(() => {
        const sync = () => {
            setSession((current) => {
                const next = readAuthSession();
                if (current === next) return current;
                if (current && next && current.email === next.email) return current;
                return next;
            });
        };
        sync();
        window.addEventListener(AUTH_CHANGE_EVENT, sync);
        window.addEventListener("storage", sync);
        window.addEventListener("focus", sync);
        return () => {
            window.removeEventListener(AUTH_CHANGE_EVENT, sync);
            window.removeEventListener("storage", sync);
            window.removeEventListener("focus", sync);
        };
    }, []);

    return session;
}
